import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const PopupNotification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-173" data-mp="wjj8x9xlot1a">
      {isVisible && <motion.div initial={{
      x: '-120%',
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-5 left-5 bg-white rounded-xl py-3.5 px-4 shadow-[0_8px_30px_rgba(0,0,0,0.15)] flex items-center gap-3 z-[9999] max-w-[280px] border-l-4 border-brown-light" data-id="element-174" data-mp="11h2m06ikazrn">
          <div className="w-[42px] h-[42px] rounded-full bg-gradient-to-br from-brown-mid to-brown-light flex items-center justify-center text-white font-black font-sans text-sm shrink-0" data-id="element-175" data-mp="1k7keqb3e9vd0">
            MR
          </div>
          <div className="font-sans" data-id="element-176" data-mp="bi3jx6v9fibw">
            <strong className="block text-[13px] text-[#222] mb-0.5" data-id="element-177" data-mp="bj55445zpl7c">
              Marcos R. de Tucumán
            </strong>
            <span className="text-xs text-[#888]" data-id="element-178" data-mp="7icxtggohqdp">
              compró el Mega Pack Tierra Viva 🌿
            </span>
            <span className="text-[10px] bg-green-brand text-white py-0.5 px-2 rounded-full inline-block mt-1" data-id="element-179" data-mp="3tngiip5hcjmr">
              hace 6 minutos
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
};